import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { makeStyles } from '@mui/styles';
import { FONT_FAMILY } from 'styles/variables/typography';
import { COLOR_GRAY_30, COLOR_GRAY_40, COLOR_GRAY_90 } from 'styles/variables/colors';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    marginBottom: theme.spacing(4),

    '& .MuiTextField-root': {
      width: '100%',
      height: 48,
    },

    '& fieldset': {
      borderColor: COLOR_GRAY_30,
    },

    '& input': {
      padding: '12.5px 14px 12.5px 0px',
    },
  },
  icon: {
    color: COLOR_GRAY_40,
  },
  label: {
    fontFamily: FONT_FAMILY,
    color: COLOR_GRAY_90,

    '&.MuiFormLabel-filled': {
      fontWeight: 600,
    },
  },
}));

const Props = {
  icon: PropTypes.string,
  marginBottom: PropTypes.number,
};

const DefaultProps = {
  icon: undefined,
  marginBottom: 0,
};

export default function IconInput({ icon, marginBottom, ...textFieldProps }) {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <TextField
        {...textFieldProps}
        InputLabelProps={{
          className: classes.label,
        }}
        InputProps={{
          startAdornment: icon && (
            <InputAdornment className={classes.icon} position="start">
              <Icon name={icon} />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

IconInput.propTypes = Props;
IconInput.defaultProps = DefaultProps;
